import PropTypes from 'prop-types';
import './style.scss';

const AbsoluteAttribute = ({value, unit}) => {
	return (
		<div className="unhab-Attribute-absolute">
			<div>{((value || value === 0) && value.toFixed(1)) || '-'}</div>
			<span>{unit || ''}</span>
		</div>
	);
};

AbsoluteAttribute.propTypes = {
	value: PropTypes.number,
	unit: PropTypes.string,
};

export default AbsoluteAttribute;
